import { render, staticRenderFns } from "./coursetestdelites.vue?vue&type=template&id=41960bc0&scoped=true"
import script from "./coursetestdelites.vue?vue&type=script&lang=js"
export * from "./coursetestdelites.vue?vue&type=script&lang=js"
import style0 from "./coursetestdelites.vue?vue&type=style&index=0&id=41960bc0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41960bc0",
  null
  
)

export default component.exports